import { CheckoutPayload } from './checkout-payload.interface';

export interface CheckoutRequest {
  overrideAchDiscountCode?: string;
  overrideCCDiscountCode?: string;
  payload: CheckoutPayload;
  retailerDomain: string;
}
